import React, { useState } from "react";
import { Play } from "lucide-react";

// Click-to-load YouTube embed for performance (loads the iframe only on play).
export const VideoEmbed = ({ videoId, title = "Video" }) => {
  const [playing, setPlaying] = useState(false);
  const thumb = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  return (
    <div
      className="relative w-full aspect-video overflow-hidden border border-white/10 bg-[#020817] group"
      data-testid="video-embed"
    >
      {playing ? (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
          title={title}
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
          className="absolute inset-0 w-full h-full"
          data-testid="video-iframe"
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          data-testid="video-play-button"
          aria-label={`Play ${title}`}
          className="absolute inset-0 w-full h-full cursor-pointer"
        >
          <img
            src={thumb}
            alt={title}
            className="absolute inset-0 w-full h-full object-cover opacity-70 transition-opacity duration-300 group-hover:opacity-90"
            onError={(e) => {
              e.currentTarget.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#020817] via-[#020817]/30 to-transparent" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="w-20 h-20 flex items-center justify-center rounded-full bg-[#4FC3F7] text-[#020817] shadow-[0_0_60px_-10px_rgba(79,195,247,0.7)] transition-transform duration-300 group-hover:scale-110">
              <Play className="w-8 h-8 ml-1" fill="currentColor" strokeWidth={0} />
            </span>
          </span>
        </button>
      )}
    </div>
  );
};
